module.exports = __webpack_public_path__ + "static/media/slider3.4f42f050.jpg";